import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import * as $ from "jquery";
import { HttpModule } from '@angular/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AngularFontAwesomeModule } from 'angular-font-awesome';


/* Angular Fire (Firebase) */ 

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule, AngularFireDatabase } from 'angularfire2/database';


/* App components and services */ 

import { AppComponent } from './app.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { DisplayProfilesComponent } from './display-profiles/display-profiles.component';
import { FilterComponent } from './display-profiles/filter/filter.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ProfileComponent } from './profile/profile.component';
import { SkillComponent } from './profile/skill/skill.component';
import { SkillFormComponent } from './profile/skill-form/skill-form.component'; 
import { SheetJSComponent } from './sheetjs.component';
import { SearchAutocomplComponent } from './search-autocompl/search-autocompl.component';
import { DeleteFormComponent, DeleteFormDialog } from './profile/delete-form/delete-form.component';

import { GetFilteredDataService } from './display-profiles/filter/get-filtered-data.service';
import { StoreService } from './store.service';


/* Angular Material */ 

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';



@NgModule({
  declarations: [
    AppComponent,
    SearchBarComponent,
    DisplayProfilesComponent,
    FilterComponent,
    LandingPageComponent, 
    ProfileComponent, 
    SkillComponent, 
    SkillFormComponent, 
    SearchAutocomplComponent, 
    SheetJSComponent, 
    DeleteFormDialog,
    DeleteFormComponent,
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireDatabaseModule, 
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    NgbModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: DisplayProfilesComponent },
      { path: 'profile/:email', component: ProfileComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'landingPage', component: ProfileComponent },
      { path: 'xl', component: SheetJSComponent },
    ]),
    BrowserAnimationsModule,
    MatAutocompleteModule, 
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule, 
    MatSlideToggleModule, 
    MatSelectModule, 
    MatIconModule, 
    MatTooltipModule, 
    MatProgressSpinnerModule, 
    MatCardModule, 
    MatCheckboxModule,
    MatDialogModule, 
    MatProgressBarModule
  ],
  providers: [
    GetFilteredDataService,
    StoreService,
  ],
  bootstrap: [AppComponent],   
  entryComponents: [
    DeleteFormComponent,
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/app.module.ts